module.exports = __webpack_public_path__ + "static/media/logo.a5cc0f69.png";